export default __webpack_public_path__ + "static/media/upright_row_end.dfd9fde2.svg";